export default __webpack_public_path__ + "static/media/Step 1_fold.4e37ace6.stl";